import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import type { FetchResult, MutationResult } from '@apollo/client';

import { showErrorAction, showMessageAction } from 'containers/Notification/actions';
import {
  useUpsertActionTemplateMutation,
  MutationMutationUpsertActionTemplateArgs,
} from 'generated/graphql';

export const useActionTemplateMutation = (
  actionTemplateId?: string
): [(data: MutationMutationUpsertActionTemplateArgs) => void, MutationResult] => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onCompleted: Exclude<
    Parameters<typeof useUpsertActionTemplateMutation>[0],
    undefined
  >['onCompleted'] = () => {
    dispatch(
      showMessageAction(actionTemplateId ? 'Action Template updated' : 'Action Template created')
    );
    history.push('/actions/templates/browse');
  };

  const onError = () => {
    dispatch(
      showErrorAction(
        `An error occurred while ${
          actionTemplateId ? 'saving' : 'updating'
        } your action template, please try again`
      )
    );
  };

  const [upsertActionTemplateMutation, result] = useUpsertActionTemplateMutation({
    onCompleted,
    onError,
    update: (cache) => {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'actionTemplates' });
    },
  });

  const mutation = (data: MutationMutationUpsertActionTemplateArgs): Promise<FetchResult> =>
    upsertActionTemplateMutation({
      variables: data,
    });

  return [mutation, result];
};
